import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Globals } from '../service/global';
import { UtilityService } from '../service/utility.service';

@Pipe({
  name: 'safeMinutes'
})
export class SafeMinutesPipe implements PipeTransform {

  constructor(private sanitized: DomSanitizer,private utilService:UtilityService,private globals:Globals) { }

  transform(minAttrList:any) {
    return this.constructTaskSec(minAttrList);
  }
  //Method to construct task secti[uon
  constructTaskSec(minAttrList: any) {
    // Start with task title as-is (no leading <br/>)
    console.log("minatte list : ",minAttrList)
    let tempHtml = '';
    if (minAttrList != null && minAttrList != undefined) {
      tempHtml = this.utilService.nvl(minAttrList.taskTitle);

      // Build a DOM to safely manipulate paragraphs and avoid stray &nbsp; creating empty <p>
      const container = document.createElement('div');
      // Remove hidden BOM/ZWSP characters that sometimes sneak into HTML (e.g., "\uFEFF").
      // These can break selectors and click handling after reload.
      const sanitizedHtml = (tempHtml || '').replace(/[\uFEFF\u200B]/g, '');
      container.innerHTML = sanitizedHtml;

      // Helper: remove trailing empty paragraphs: <p>&nbsp;</p> or whitespace-only
      const isEmptyP = (p: HTMLElement) => !p.textContent || p.textContent.replace(/\u00a0|&nbsp;/g, ' ').trim() === '';
      while (container.lastElementChild && container.lastElementChild.tagName === 'P' && isEmptyP(container.lastElementChild as HTMLElement)) {
        container.removeChild(container.lastElementChild);
      }

      // Determine the paragraph to append owner/due-date info
      let targetP = container.querySelector('p:last-of-type') as HTMLParagraphElement | null;
      if (!targetP) {
        targetP = document.createElement('p');
        container.appendChild(targetP);
      }

      const owners: any[] = (minAttrList.actionItemOwner || []) as any[];
      const hasGuest = this.utilService.nvl(minAttrList.guestOwnerName) !== '';
      const hasOwners = owners && owners.length > 0;
      const dueDateStr: string = this.utilService.nvl(minAttrList.dueDateStr);

      // Append a normal space before meta if paragraph does not already end with space
      const endsWithSpace = /[\s\u00a0]$/.test(targetP.innerHTML);
      if (!endsWithSpace && (hasOwners || hasGuest || dueDateStr)) {
        targetP.appendChild(document.createTextNode(' '));
      }

      if (hasOwners || hasGuest) {
        // Owner(s): label
        const ownerLbl = document.createElement('span');
        ownerLbl.className = 'assignCls';
        ownerLbl.setAttribute('contenteditable', 'false');
        ownerLbl.textContent = 'Owner(s): ';
        targetP.appendChild(ownerLbl);

        // Owners list
        owners.forEach((o, index) => {
          const span = document.createElement('span');
          span.className = 'atwho-inserted';
          span.setAttribute('data-atwho-at-query', '@');
          span.setAttribute('id', String(o.fkSecUserOwner || o.userId || ''));
          span.setAttribute('fkuserid', String(o.fkSecUserOwner || o.userId || ''));
          span.setAttribute('contenteditable', 'false');
          // Normalize ownerName to avoid trailing spaces/commas from DB
          const name = String(o.ownerName || '').replace(/[,\s]+$/g, '');
          // Add comma+space INSIDE the span for all but the last owner
          if (owners.length > 1 && index < owners.length - 1) {
            span.textContent = name + ', ';
          } else {
            // Last owner gets just a space after
            span.textContent = name + ' ';
          }
          targetP.appendChild(span);
        });
      }

      if (dueDateStr) {
        const dateSpan = document.createElement('span');
        // Exact required structure for task due date
        // <span class="minDateCls" contenteditable="false"><span class="dueLabelCls">Due Date: &nbsp;</span>Feb 11, 2026<span class="taskTimezoneCls"> IST</span></span>
        dateSpan.className = 'minDateCls';
        dateSpan.setAttribute('contenteditable', 'false');

        const label = document.createElement('span');
        label.className = 'dueLabelCls';
        label.innerHTML = 'Due Date: &nbsp;';
        dateSpan.appendChild(label);
        dateSpan.appendChild(document.createTextNode(dueDateStr));
        if (this.globals.showTimezone_Date != null && this.globals.showTimezone_Date == 'Y') {
          const tz = document.createElement('span');
          tz.className = 'taskTimezoneCls';
          tz.textContent = ' ' + this.globals.vShortTimeZone;
          dateSpan.appendChild(tz);
        }
        // Add a trailing normal space after date for UX, plus a non-breaking space node
        targetP.appendChild(document.createTextNode(' '));
        targetP.appendChild(dateSpan);
        // Append a real NBSP so caret can be placed after the non-editable span post-refresh
        targetP.appendChild(document.createTextNode('\u00A0'));
      }
      // Final HTML back from container
      tempHtml = container.innerHTML;
    }
    console.log(tempHtml,'tempHtml');
    return tempHtml;
  }
}
